
import HttpClient from '../HttpService';

function create(data) {
    return HttpClient.post(`/matrix`, data);
}

function update(matrix) {
    return HttpClient.put(`/matrix/${matrix.uuid}`, matrix);
}

function getByUUID(matrixUUID) {
    return HttpClient.get(`/matrix/${matrixUUID}`);
}

function getMostRecentMatrixFromPatient(patientUUID) {
    return HttpClient.get(`/matrix/mostrecent/${patientUUID}`);
}


export default {
    create,
    update,
    getByUUID,
    getMostRecentMatrixFromPatient,
}
